/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AgreementsControllerGetTicketStatusEmailConfig$Params {
  id: number;
  ticket_status_id: number;
}

export function agreementsControllerGetTicketStatusEmailConfig(http: HttpClient, rootUrl: string, params: AgreementsControllerGetTicketStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerGetTicketStatusEmailConfig.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('ticket_status_id', params.ticket_status_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

agreementsControllerGetTicketStatusEmailConfig.PATH = '/agreements/{id}/ticket-status-email-configs/{ticket_status_id}';
